export const CALL_SCRIPT_STEP_KEY_VOICEMAIL = 'voicemail';
